import './assets/scss/main.scss';
import Home from './pages/Home';
import { useRoutes } from 'react-router-dom';
import PersonalForm from './pages/PersonalForm';
import CardCustom from './pages/CardCustom';

const App = () => {
  let element = useRoutes([
    {path: '/', element: <Home />},
    {path: '/datos-personales', element: <PersonalForm />},
    {path: '/tu-tarjeta-ideal', element: <CardCustom />}
  ]);

  return element;
}

export default App;
